// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mexHr{overflow:hidden;position:relative}.Pfymm{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(40,40,99,.08);pointer-events:none;z-index:1}.d43vT{position:absolute;top:32px;left:32px;right:32px;bottom:32px;display:flex;flex-direction:column;z-index:2}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBox": `mexHr`,
	"overlay": `Pfymm`,
	"contentArea": `d43vT`
};
export default ___CSS_LOADER_EXPORT___;
